import { Modal } from 'antd'
import React from 'react'
import { Icon } from '@iconify/react'
import styles from './procedure-image-preview.module.scss'

type ProcedureImagePreviewProps = {
  isOpen: boolean
  onClose: () => void
  imageSrc: string | null
}

export const ProcedureImagePreview = ({
  isOpen,
  onClose,
  imageSrc,
}: ProcedureImagePreviewProps) => {
  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      centered
      width='auto'
      styles={{ body: { padding: 0 } }}
      closable={false}
      maskClosable>
      {imageSrc ? (
        <img
          src={imageSrc}
          alt='Procedure Preview'
          className={styles.previewImage}
          onClick={onClose}
        />
      ) : (
        <div className={styles.fallbackContainer}>
          <Icon icon='mdi:image-off-outline' width={48} height={48} />
          <span>No image available</span>
        </div>
      )}
    </Modal>
  )
}
